import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaUser, FaBirthdayCake, FaGraduationCap, FaBriefcase, FaHandHoldingHeart, FaFileSignature, FaCalendarAlt, FaRegUser, FaRegBuilding, FaPhoneAlt, FaEnvelope, FaPen, FaRegFileAlt, FaCheckCircle, FaShieldAlt } from 'react-icons/fa';
import H1 from '../Images/Hma.jpeg';
import L1 from '../Images/logo-w.png';
import axios from 'axios';

const Form3f3 = () => {

    const [formStep, setFormStep] = useState(1);
    const [formData, setFormData] = useState({
        name: '',
        address: '',
        phone: '',
        email: '',
        chiefPromoter: '',
        designation: '',
        yearOfIncorporation: '',
        areasOfOperation: '',
        attendAwards: '',
        willingToSupplement: '',
        willingToPresent: '',
        writeUp: '',
        otherInfo: '',
        legalCompliance: {
            statutoryApprovals: false,
            noPFTaxLiabilities: false,
            noOffences: false,
            notNPA: false,
            noChildEmployment: false,
        },
        applicantName: '',
        applicantDesignation: '',
        applicantEmail: '',
        applicantPhone: '',
        signature: '',
    });

    const [signatureFile, setSignatureFile] = useState(null);

    const handleSignatureChange = (e) => {
        setSignatureFile(e.target.files[0]);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData({
            ...formData,
            legalCompliance: {
                ...formData.legalCompliance,
                [name]: checked ? 1 : 0,
            },
        });
    };

    const [form1_id, setForm1Id] = useState('');
    const [email, setForm1Email] = useState('');

    const handleSubmit1 = async (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();
        formDataToSend.append('name', formData.name);
        formDataToSend.append('address', formData.address);
        formDataToSend.append('phone', formData.phone);
        formDataToSend.append('email', formData.email);
        formDataToSend.append('chiefPromoter', formData.chiefPromoter);
        formDataToSend.append('designation', formData.designation);
        formDataToSend.append('yearOfIncorporation', formData.yearOfIncorporation);
        formDataToSend.append('areasOfOperation', formData.areasOfOperation);
        formDataToSend.append('attendAwards', formData.attendAwards);
        formDataToSend.append('willingToSupplement', formData.willingToSupplement);
        formDataToSend.append('willingToPresent', formData.willingToPresent);
        formDataToSend.append('writeUp', formData.writeUp);
        formDataToSend.append('otherInfo', formData.otherInfo);

        formDataToSend.append('statutoryApprovals', formData.legalCompliance.statutoryApprovals ? '1' : '0');
        formDataToSend.append('noPFTaxLiabilities', formData.legalCompliance.noPFTaxLiabilities ? '1' : '0');
        formDataToSend.append('noOffences', formData.legalCompliance.noOffences ? '1' : '0');
        formDataToSend.append('notNPA', formData.legalCompliance.notNPA ? '1' : '0');
        formDataToSend.append('noChildEmployment', formData.legalCompliance.noChildEmployment ? '1' : '0');

        formDataToSend.append('applicantName', formData.applicantName);
        formDataToSend.append('applicantDesignation', formData.applicantDesignation);
        formDataToSend.append('applicantEmail', formData.applicantEmail);
        formDataToSend.append('applicantPhone', formData.applicantPhone);

        if (signatureFile) {
            formDataToSend.append('signature', signatureFile);
        }

        try {
            const response = await axios.post('https://rvapi.emedha.in/pages/api/api-form1/submit', formDataToSend, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            console.log(response.data);
            setForm1Id(response.data.form1_id);
            setForm1Email(response.data.email);
            setFormStep(2);
            alert('Form submitted successfully');
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('Failed to submit form. Please try again.');
        }
    };


    //  ---------> form 2

    const [snapshotOfOrganisation, setSnapshotOfOrganisation] = useState('');
    const [vision, setVision] = useState('');
    const [achievementsOfOrganisation, setAchievementsOfOrganisation] = useState('');
    const [contributionToExchequer, setContributionToExchequer] = useState('');
    const [sizeOfOrganisationBelow10, setSizeOfOrganisationBelow10] = useState('');
    const [sizeOfOrganisation10to20, setSizeOfOrganisation10to20] = useState('');
    const [sizeOfOrganisation20to50, setSizeOfOrganisation20to50] = useState('');
    const [sizeOfOrganisationAbove50, setSizeOfOrganisationAbove50] = useState('');
    const [ownershipSoleProprietor, setOwnershipSoleProprietor] = useState(false);
    const [ownershipPartnershipFirm, setOwnershipPartnershipFirm] = useState(false);
    const [ownershipPrivateLimitedCompany, setOwnershipPrivateLimitedCompany] = useState(false);
    const [ownershipLimitedCompany, setOwnershipLimitedCompany] = useState(false);
    const [ownershipCooperativeSociety, setOwnershipCooperativeSociety] = useState(false);
    const [sectorPrivate, setSectorPrivate] = useState(false);
    const [sectorPublic, setSectorPublic] = useState(false);
    const [sectorGovernmentCentral, setSectorGovernmentCentral] = useState(false);
    const [sectorGovernmentState, setSectorGovernmentState] = useState(false);
    const [sectorOthers, setSectorOthers] = useState(false);
    const [noOfEmployeesLessThan20, setNoOfEmployeesLessThan20] = useState('');
    const [noOfEmployees20to50, setNoOfEmployees20to50] = useState('');
    const [noOfEmployees50to100, setNoOfEmployees50to100] = useState('');
    const [noOfEmployeesAbove100, setNoOfEmployeesAbove100] = useState('');
    const [financialResults2021_22, setFinancialResults2021_22] = useState('');
    const [financialResults2022_23, setFinancialResults2022_23] = useState('');
    const [financialResults2023_24, setFinancialResults2023_24] = useState('');

    const [main_products_services_description1, setMainProductsServicesDescription1] = useState('');
    const [main_products_services_capacity1, setMainProductsServicesCapacity1] = useState('');
    const [main_products_services_description2, setMainProductsServicesDescription2] = useState('');
    const [main_products_services_capacity2, setMainProductsServicesCapacity2] = useState('');
    const [main_products_services_description3, setMainProductsServicesDescription3] = useState('');
    const [main_products_services_capacity3, setMainProductsServicesCapacity3] = useState('');
    const [major_facilities_land_area, setMajorFacilitiesLandArea] = useState('');
    const [major_facilities_factory_built_up_area, setMajorFacilitiesFactoryBuiltUpArea] = useState('');
    const [major_facilities_major_equipment, setMajorFacilitiesMajorEquipment] = useState('');
    const [major_facilities_specialized_facility, setMajorFacilitiesSpecializedFacility] = useState('');
    const [major_facilities_services, setMajorFacilitiesServices] = useState('');
    const [technology_adopted_traditional, setTechnologyAdoptedTraditional] = useState(false);
    const [technology_adopted_indigenous, setTechnologyAdoptedIndigenous] = useState(false);
    const [technology_adopted_in_house_r_d, setTechnologyAdoptedInHouseRD] = useState(false);
    const [technology_adopted_foreign_technology, setTechnologyAdoptedForeignTechnology] = useState(false);
    const [technology_adopted_franchise, setTechnologyAdoptedFranchise] = useState(false);
    const [technology_adopted_comment, setTechnologyAdoptedComment] = useState('');
    const [quality_compliance_iso, setQualityComplianceIso] = useState(false);
    const [quality_compliance_bis, setQualityComplianceBis] = useState(false);
    const [quality_compliance_gmp_who_fda_haccp, setQualityComplianceGmpWhoFdaHaccp] = useState(false);
    const [quality_compliance_other, setQualityComplianceOther] = useState(false);
    const [quality_compliance_comment, setQualityComplianceComment] = useState('');
    const [management_functions_human_resources_department, setManagementFunctionsHumanResourcesDepartment] = useState(false);
    const [management_functions_finance_accounts, setManagementFunctionsFinanceAccounts] = useState(false);
    const [management_functions_marketing_business_development, setManagementFunctionsMarketingBusinessDevelopment] = useState(false);
    const [management_functions_r_d, setManagementFunctionsRD] = useState(false);
    const [management_functions_internal_audit, setManagementFunctionsInternalAudit] = useState(false);
    const [management_functions_quality_assurance, setManagementFunctionsQualityAssurance] = useState(false);
    const [management_functions_other, setManagementFunctionsOther] = useState(false);
    const [management_functions_comment, setManagementFunctionsComment] = useState('');
    const [level_of_it_intervention_use_of_erp, setLevelOfITInterventionUseOfERP] = useState(false);
    const [level_of_it_intervention_customized_software, setLevelOfITInterventionCustomizedSoftware] = useState(false);
    const [level_of_it_intervention_general_office_solutions, setLevelOfITInterventionGeneralOfficeSolutions] = useState(false);
    const [level_of_it_intervention_no_it_facility, setLevelOfITInterventionNoITFacility] = useState(false);
    const [level_of_it_intervention_comment, setLevelOfITInterventionComment] = useState('');
    const [award_recognition_yes, setAwardRecognitionYes] = useState(false);
    const [award_recognition_no, setAwardRecognitionNo] = useState(false);
    const [award_recognition_comment, setAwardRecognitionComment] = useState('');

    const [strategic_plan_for_future_yes, setStrategicPlanForFutureYes] = useState(false);
    const [strategic_plan_for_future_no, setStrategicPlanForFutureNo] = useState(false);
    const [strategic_plan_for_future_comment, setStrategicPlanForFutureComment] = useState('');

    const [about_product_service_description, setAboutProductServiceDescription] = useState('');
    const [about_product_service_capacity, setAboutProductServiceCapacity] = useState('');
    const [about_product_service_features, setAboutProductServiceFeatures] = useState('');
    const [about_product_service_uniqueness, setAboutProductServiceUniqueness] = useState('');
    const [about_product_service_market, setAboutProductServiceMarket] = useState('');
    const [about_product_service_export_content_in_turnover, setAboutProductServiceExportContentInTurnover] = useState('');

    const [about_chief_promoter_educational_qualification, setAboutChiefPromoterEducationalQualification] = useState('');
    const [about_chief_promoter_experience_in_line, setAboutChiefPromoterExperienceInLine] = useState('');
    const [about_chief_promoter_first_generation_entrepreneur, setAboutChiefPromoterFirstGenerationEntrepreneur] = useState('');
    const [about_chief_promoter_contribution_to_organisation, setAboutChiefPromoterContributionToOrganisation] = useState('');
    const [about_chief_promoter_relevant_details, setAboutChiefPromoterRelevantDetails] = useState('');

    const [signatureUrl, setSignatureUrl] = useState('');
    const [name, setName] = useState('');
    const [designation, setDesignation] = useState('');

    // Handle form submission
    const handleSubmit2 = async (e) => {
        e.preventDefault();

        const formData = {
            snapshot_of_organisation: snapshotOfOrganisation,
            vision: vision,
            achievements_of_organisation: achievementsOfOrganisation,
            contribution_to_exchequer: contributionToExchequer,
            size_of_organisation_below_10: sizeOfOrganisationBelow10,
            size_of_organisation_10_20: sizeOfOrganisation10to20,
            size_of_organisation_20_50: sizeOfOrganisation20to50,
            size_of_organisation_above_50: sizeOfOrganisationAbove50,
            ownership_sole_proprietor: ownershipSoleProprietor,
            ownership_partnership_firm: ownershipPartnershipFirm,
            ownership_private_limited_company: ownershipPrivateLimitedCompany,
            ownership_limited_company: ownershipLimitedCompany,
            ownership_cooperative_society: ownershipCooperativeSociety,
            sector_private: sectorPrivate,
            sector_public: sectorPublic,
            sector_government_central: sectorGovernmentCentral,
            sector_government_state: sectorGovernmentState,
            sector_others: sectorOthers,
            no_of_employees_less_than_20: noOfEmployeesLessThan20,
            no_of_employees_20_50: noOfEmployees20to50,
            no_of_employees_50_100: noOfEmployees50to100,
            no_of_employees_above_100: noOfEmployeesAbove100,
            financial_results_2021_22: financialResults2021_22,
            financial_results_2022_23: financialResults2022_23,
            financial_results_2023_24: financialResults2023_24,

            main_products_services_description1,
            main_products_services_capacity1,
            main_products_services_description2,
            main_products_services_capacity2,
            main_products_services_description3,
            main_products_services_capacity3,
            major_facilities_land_area,
            major_facilities_factory_built_up_area,
            major_facilities_major_equipment,
            major_facilities_specialized_facility,
            major_facilities_services,
            technology_adopted_traditional,
            technology_adopted_indigenous,
            technology_adopted_in_house_r_d,
            technology_adopted_foreign_technology,
            technology_adopted_franchise,
            technology_adopted_comment,
            quality_compliance_iso,
            quality_compliance_bis,
            quality_compliance_gmp_who_fda_haccp,
            quality_compliance_other,
            quality_compliance_comment,
            management_functions_human_resources_department,
            management_functions_finance_accounts,
            management_functions_r_d,
            management_functions_internal_audit,
            management_functions_quality_assurance,
            management_functions_other,
            management_functions_marketing_business_development,
            management_functions_comment,
            level_of_it_intervention_use_of_erp,
            level_of_it_intervention_customized_software,
            level_of_it_intervention_general_office_solutions,
            level_of_it_intervention_no_it_facility,
            level_of_it_intervention_comment,
            award_recognition_yes,
            award_recognition_no,
            award_recognition_comment,
            strategic_plan_for_future_yes,
            strategic_plan_for_future_no,
            strategic_plan_for_future_comment,
            about_product_service_description,
            about_product_service_capacity,
            about_product_service_features,
            about_product_service_uniqueness,
            about_product_service_market,
            about_product_service_export_content_in_turnover,
            about_chief_promoter_educational_qualification,
            about_chief_promoter_experience_in_line,
            about_chief_promoter_first_generation_entrepreneur,
            about_chief_promoter_contribution_to_organisation,
            about_chief_promoter_relevant_details,

            signature_url: signatureUrl,
            name,
            designation,
            form1_id: form1_id,
        };

        try {
            const response = await axios.post('https://rvapi.emedha.in/pages/api/submit-nomination', formData);
            alert('Data submitted successfully');
            setFormStep(3);
            console.log('respose Data', response);
        } catch (error) {
            console.error('There was an error submitting the form!', error);
            alert('Error submitting form');
        }
    };

    // form 3------------------------------------------->

    const [namee, setNamee] = useState('');
    const [age, setAge] = useState('');
    const [qualification, setQualification] = useState({
        discipline: ["Technical", "Financial", "Management", "Professional", "Other"],
        pg: ["", "", "", "", ""],
        graduate: ["", "", "", "", ""],
        other: ["", "", "", "", ""]
    });
    const [experience, setExperience] = useState({
        total_years: "",
        same_line: "",
        same_organization: ""
    });
    const [contributor_role, setContributorRole] = useState('');
    const [first_gen_entrepreneur, setFirstGenEntrepreneur] = useState('');
    const [contribution_text, setContributionText] = useState('');
    const [checkboxes, setCheckboxes] = useState([]);
    const [comments, setComments] = useState('');
    const [comment1, setComment1] = useState('');
    const [signature_image, setSignatureImage] = useState(null);
    const [date, setDate] = useState('');
    const [name1, setName1] = useState('');
    const [showModal, setShowModal] = useState(false);

    const handleModalClose = () => setShowModal(false);
    const handleModalShow = () => setShowModal(true);

    const handleQualificationChange = (index, field, value) => {
        setQualification(prev => {
            const updatedQualification = { ...prev };
            updatedQualification[field][index] = value;
            return updatedQualification;
        });
    };

    const handleExperienceChange = (e) => {
        const { name, value } = e.target;
        setExperience(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleCheckboxChangeg = (e) => {
        const { checked, value } = e.target;
        setCheckboxes(prev => {
            const updatedCheckboxes = checked
                ? [...prev, value]
                : prev.filter(item => item !== value);
            return updatedCheckboxes;
        });
    };

    const handleFileChange = (e) => {
        setSignatureImage(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = new FormData();
        data.append('name', namee);
        data.append('age', age);
        data.append("qualification", JSON.stringify(qualification));
        data.append("experience", JSON.stringify(experience));
        data.append('contributor_role', contributor_role);
        data.append('first_gen_entrepreneur', first_gen_entrepreneur);
        data.append('contribution_text', contribution_text);
        data.append('checkboxes', JSON.stringify(checkboxes));
        data.append('comments', comments);
        data.append('comment1', comment1);
        data.append('date', date);
        data.append('name1', name1);
        
        data.append('form1_id', form1_id);
        data.append('email', email);

        if (signature_image) {
            data.append('signature_image', signature_image);
        }

        try {
            const response = await axios.post('https://rvapi.emedha.in/pages/api/submit-form', data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            console.log("Form submitted successfully:", response.data);
            alert('Form submitted successfully!');
            window.location.reload();
        } catch (error) {
            alert('Error submitting form!');
        }
    };


    return (
        <>
            <img src={H1} alt="item" className="img-fluid" style={{ height: '200px', width: '100%' }} />

            <div className='mt-4' style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                {[1, 2, 3].map((stepNumber) => (
                    <div
                        key={stepNumber} style={{ width: '60px', height: '30px', borderRadius: '10%', backgroundColor: formStep === stepNumber ? '#007bff' : '#ccc', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', cursor: formStep >= stepNumber ? 'pointer' : 'not-allowed', margin: '0 5px', opacity: formStep >= stepNumber ? 1 : 0.5, }}
                        onClick={() => { if (formStep >= stepNumber) { setFormStep(stepNumber); } }}>
                        {stepNumber}
                    </div>
                ))}
            </div>

            {formStep === 1 && (
                <div className='container'>
                    <h3 style={{ textAlign: 'center', marginBottom: '20px', textTransform: 'uppercase' }}>Declaration Form for Nominations</h3>
                    <form >
                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaRegUser /> Name:</label>
                                <input type="text" name="name" placeholder="Enter Name" value={formData.name} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaRegBuilding /> Address:</label>
                                <input type="text" name="address" placeholder="Enter Address" value={formData.address} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaPhoneAlt /> Phone:</label>
                                <input type="text" name="phone" placeholder="Enter Phone" value={formData.phone} maxLength={10} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaEnvelope /> Email:</label>
                                <input type="email" name="email" placeholder="Enter Email" value={formData.email} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaPen /> Chief Promoter Name:</label>
                                <input type="text" name="chiefPromoter" placeholder="Enter Chief Promoter Name" value={formData.chiefPromoter} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaPen /> Designation:</label>
                                <input type="text" name="designation" placeholder="Enter Designation" value={formData.designation} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaRegFileAlt /> Year of Incorporation:</label>
                                <input type="text" name="yearOfIncorporation" value={formData.yearOfIncorporation} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaRegFileAlt /> Areas of Operation:</label>
                                <input type="text" name="areasOfOperation" value={formData.areasOfOperation} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaCheckCircle /> If selected, will you attend to the awards function to accept the award:</label>
                                <select name="attendAwards" value={formData.attendAwards} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required>
                                    <option value="">select</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaCheckCircle /> Are you willing to supplement any further information?</label>
                                <select name="willingToSupplement" value={formData.willingToSupplement} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required>
                                    <option value="">select</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaCheckCircle /> Are you willing to make a presentation before the jury?</label>
                                <select name="willingToPresent" value={formData.willingToPresent} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required>
                                    <option value="">select</option>
                                    <option value="YES">YES</option>
                                    <option value="NO">NO</option>
                                </select>
                            </div>
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <label><FaRegFileAlt /> Write a brief 200-word write-up on why you consider yourself suitable for this Award:</label>
                            <textarea name="writeUp" value={formData.writeUp} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} rows="4" required />
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <label><FaRegFileAlt /> Any other relevant information in support of the proposal:</label>
                            <textarea name="otherInfo" value={formData.otherInfo} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} rows="4" />
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <label><FaShieldAlt /> Legal & Statutory compliance:</label>
                            <div style={{ border: '2px solid #000', padding: '15px', borderRadius: '5px', backgroundColor: '#f8f9fa' }}>
                                <label>
                                    <input type="checkbox" name="statutoryApprovals" checked={formData.legalCompliance.statutoryApprovals} onChange={handleCheckboxChange} />
                                    <FaShieldAlt /> Has all Statutory approvals
                                </label>
                                <br />
                                <label>
                                    <input type="checkbox" name="noPFTaxLiabilities" checked={formData.legalCompliance.noPFTaxLiabilities} onChange={handleCheckboxChange} />
                                    <FaShieldAlt /> No PF/Tax liabilities
                                </label>
                                <br />
                                <label>
                                    <input type="checkbox" name="noOffences" checked={formData.legalCompliance.noOffences} onChange={handleCheckboxChange} />
                                    <FaShieldAlt /> Not involved in any Civil/Criminal/Economic offences
                                </label>
                                <br />
                                <label>
                                    <input type="checkbox" name="notNPA" checked={formData.legalCompliance.notNPA} onChange={handleCheckboxChange} />
                                    <FaShieldAlt /> Not an NPA with Banks/FI
                                </label>
                                <br />
                                <label>
                                    <input type="checkbox" name="noChildEmployment" checked={formData.legalCompliance.noChildEmployment} onChange={handleCheckboxChange} />
                                    <FaShieldAlt /> No Child employment
                                </label>
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaRegUser /> Name of Applicant:</label>
                                <input type="text" name="applicantName" value={formData.applicantName} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaPen /> Designation (CEO/MD/Chief Promoter):</label>
                                <input type="text" name="applicantDesignation" value={formData.applicantDesignation} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '15px' }}>
                            <div style={{ flex: '1', marginRight: '15px', marginBottom: '15px' }}>
                                <label><FaEnvelope /> Email ID:</label>
                                <input type="email" name="applicantEmail" value={formData.applicantEmail} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                            <div style={{ flex: '1', marginBottom: '15px' }}>
                                <label><FaPhoneAlt /> Phone/Mobile:</label>
                                <input type="text" name="applicantPhone" value={formData.applicantPhone} onChange={handleChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                            </div>
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <label><FaRegFileAlt /> Signature of Applicant and Company seal:</label>
                            <input type="file" name="signature" accept="image/*" onChange={handleSignatureChange} style={{ width: '100%', padding: '8px', fontSize: '14px' }} required />
                        </div>

                        <div className='mb-2' style={{ textAlign: 'center' }}>
                            <button onClick={handleSubmit1} className="btn btn-primary w-100">Submit</button>
                        </div>
                    </form>
                </div>
            )}

            {formStep === 2 && (
                <div className="container">
                    <form>
                        <h4 className='mt-2 mb-2 text-center'>FORM - 2</h4>
                        <p className='mb-0'>A. About the Organisation: (Write up in brief)</p>
                        <div className="mb-3">
                            <label htmlFor="organizationSnapshot" className="form-label">i. A snapshot of the Organisation, chief promoter, the key activities, challenges faced, competition, exports etc.</label>
                            <textarea value={snapshotOfOrganisation} onChange={(e) => setSnapshotOfOrganisation(e.target.value)} className="form-control" id="organizationSnapshot" rows="3" placeholder="Write here..." style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* Section ii */}
                        <div className="mb-3">
                            <label htmlFor="visionMission" className="form-label">ii. Vision, mission and policy of organization</label>
                            <textarea value={vision} onChange={(e) => setVision(e.target.value)} className="form-control" id="visionMission" rows="3" placeholder="Write here..." style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* Section iii */}
                        <div className="mb-3">
                            <label htmlFor="achievements" className="form-label">iii. Important achievements of Organisation in the past few years</label>
                            <textarea value={achievementsOfOrganisation} onChange={(e) => setAchievementsOfOrganisation(e.target.value)} className="form-control" id="achievements" rows="3" placeholder="Write here..." style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* Section iv */}
                        <div className="mb-3">
                            <label htmlFor="contribution" className="form-label">iv. Contribution to exchequer, society, CSR etc.</label>
                            <textarea value={contributionToExchequer} onChange={(e) => setContributionToExchequer(e.target.value)} className="form-control" id="contribution" rows="3" placeholder="Write here..." style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* Size of Organisation */}
                        <h5>1. Size of Organisation: (investment in plant & machinery) in Rs Cr</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>A. Below 10</td>
                                    <td><input type="radio" id="below10" name="size" value="below10" onChange={() => setSizeOfOrganisationBelow10('Below 10')} /></td>
                                </tr>
                                <tr>
                                    <td>B. 10 - 20</td>
                                    <td> <input type="radio" id="10to20" name="size" value="10to20" onChange={() => setSizeOfOrganisation10to20('10-20')} /></td>
                                </tr>
                                <tr>
                                    <td>C. 20 - 50</td>
                                    <td><input type="radio" id="20to50" name="size" value="20to50" onChange={() => setSizeOfOrganisation20to50('20-50')} /></td>
                                </tr>
                                <tr>
                                    <td>D. Above 50</td>
                                    <td> <input type="radio" id="above50" name="size" value="above50" onChange={() => setSizeOfOrganisationAbove50('Above 50')} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Ownership */}
                        <h5>2. Ownership (tick as applicable)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>A. Sole Proprietor</td>
                                    <td> <input type="checkbox" id="soleProprietor" onChange={() => setOwnershipSoleProprietor(!ownershipSoleProprietor)} /></td>
                                </tr>
                                <tr>
                                    <td>B. Partnership Firm</td>
                                    <td> <input type="checkbox" id="partnershipFirm" onChange={() => setOwnershipPartnershipFirm(!ownershipPartnershipFirm)} /></td>
                                </tr>
                                <tr>
                                    <td>C. Private limited Company</td>
                                    <td> <input type="checkbox" id="privateLimitedCompany" onChange={() => setOwnershipPrivateLimitedCompany(!ownershipPrivateLimitedCompany)} /></td>
                                </tr>
                                <tr>
                                    <td>D. Limited Company</td>
                                    <td> <input type="checkbox" id="limitedCompany" onChange={() => setOwnershipLimitedCompany(!ownershipLimitedCompany)} /></td>
                                </tr>
                                <tr>
                                    <td>E. Cooperative Society</td>
                                    <td> <input type="checkbox" id="cooperativeSociety" onChange={() => setOwnershipCooperativeSociety(!ownershipCooperativeSociety)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Sector */}
                        <h5>3. Sector (tick as applicable)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>A. Private</td>
                                    <td>  <input type="checkbox" id="private" onChange={() => setSectorPrivate(!sectorPrivate)} /></td>
                                </tr>
                                <tr>
                                    <td>B. Public</td>
                                    <td> <input type="checkbox" id="public" onChange={() => setSectorPublic(!sectorPublic)} /></td>
                                </tr>
                                <tr>
                                    <td>C. Government - Central</td>
                                    <td> <input type="checkbox" id="governmentCentral" onChange={() => setSectorGovernmentCentral(!sectorGovernmentCentral)} /></td>
                                </tr>
                                <tr>
                                    <td>D. Government - State</td>
                                    <td> <input type="checkbox" id="governmentState" onChange={() => setSectorGovernmentState(!sectorGovernmentState)} /></td>
                                </tr>
                                <tr>
                                    <td>E. Others</td>
                                    <td>  <input type="checkbox" id="others" onChange={() => setSectorOthers(!sectorOthers)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* No of Employees */}
                        <h5>4. No of Employees (tick as applicable and mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>A. Less than 20</td>
                                    <td> <input type="checkbox" id="lessThan20" onChange={() => setNoOfEmployeesLessThan20(!noOfEmployeesLessThan20)} /></td>
                                </tr>
                                <tr>
                                    <td>B. 20 - 50</td>
                                    <td> <input type="checkbox" id="20to50Employees" onChange={() => setNoOfEmployees20to50(!noOfEmployees20to50)} /></td>
                                </tr>
                                <tr>
                                    <td>C. 50 - 100</td>
                                    <td> <input type="checkbox" id="50to100Employees" onChange={() => setNoOfEmployees50to100(!noOfEmployees50to100)} /></td>
                                </tr>
                                <tr>
                                    <td>D. Above 100</td>
                                    <td> <input type="checkbox" id="above100Employees" onChange={() => setNoOfEmployeesAbove100(!noOfEmployeesAbove100)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Financial results for last 3 years */}
                        <h5>5. Financial results for last 3 years (As per Annual reports) (In Rs Cr)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Year</th>
                                    <th>Turnover</th>
                                    <th>Net Profit</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>2021-22</td>
                                    <td>0-10</td>
                                    <td>   <input type="text" className="form-control" value={financialResults2021_22} onChange={(e) => setFinancialResults2021_22(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>2022-23</td>
                                    <td>10-50</td>
                                    <td> <input type="text" className="form-control" value={financialResults2022_23} onChange={(e) => setFinancialResults2022_23(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>2023-24</td>
                                    <td>50-100 & above</td>
                                    <td> <input type="text" className="form-control" value={financialResults2023_24} onChange={(e) => setFinancialResults2023_24(e.target.value)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Main Products/Services */}
                        <h5>6. Main Products/Services (Mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Description</th>
                                    <th>Capacity</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td><input type="text" className="form-control" value={main_products_services_description1} onChange={(e) => setMainProductsServicesDescription1(e.target.value)} /></td>
                                    <td><input type="text" className="form-control" value={main_products_services_capacity1} onChange={(e) => setMainProductsServicesCapacity1(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td><input type="text" className="form-control" value={main_products_services_description2} onChange={(e) => setMainProductsServicesDescription2(e.target.value)} /></td>
                                    <td><input type="text" className="form-control" value={main_products_services_capacity2} onChange={(e) => setMainProductsServicesCapacity2(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td><input type="text" className="form-control" value={main_products_services_description3} onChange={(e) => setMainProductsServicesDescription3(e.target.value)} /></td>
                                    <td><input type="text" className="form-control" value={main_products_services_capacity3} onChange={(e) => setMainProductsServicesCapacity3(e.target.value)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        <h5>7. Major facilities (mention details) (Fill relevant details based on type of your company)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Facility</th>
                                    <th>Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>a</td>
                                    <td>Land area</td>
                                    <td><input type="text" className="form-control" value={major_facilities_land_area} onChange={(e) => setMajorFacilitiesLandArea(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>b</td>
                                    <td>Factory built up area</td>
                                    <td><input type="text" className="form-control" value={major_facilities_factory_built_up_area} onChange={(e) => setMajorFacilitiesFactoryBuiltUpArea(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>c</td>
                                    <td>Major Equipment</td>
                                    <td><input type="text" className="form-control" value={major_facilities_major_equipment} onChange={(e) => setMajorFacilitiesMajorEquipment(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>d</td>
                                    <td>Specialized Facility</td>
                                    <td><input type="text" className="form-control" value={major_facilities_specialized_facility} onChange={(e) => setMajorFacilitiesSpecializedFacility(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>e</td>
                                    <td>Services</td>
                                    <td><input type="text" className="form-control" value={major_facilities_services} onChange={(e) => setMajorFacilitiesServices(e.target.value)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        <h5>8. Technology adopted (tick as applicable and mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>a. Traditional</td>
                                    <td><input type="checkbox" checked={technology_adopted_traditional} onChange={(e) => setTechnologyAdoptedTraditional(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>b. Indigenous</td>
                                    <td><input type="checkbox" checked={technology_adopted_indigenous} onChange={(e) => setTechnologyAdoptedIndigenous(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>c. In house R & D</td>
                                    <td><input type="checkbox" checked={technology_adopted_in_house_r_d} onChange={(e) => setTechnologyAdoptedInHouseRD(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>d. Foreign Technology</td>
                                    <td><input type="checkbox" checked={technology_adopted_foreign_technology} onChange={(e) => setTechnologyAdoptedForeignTechnology(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>e. Franchise</td>
                                    <td><input type="checkbox" checked={technology_adopted_franchise} onChange={(e) => setTechnologyAdoptedFranchise(e.target.checked)} /></td>
                                </tr>
                            </tbody>
                        </table>
                        <textarea className="form-control mt-2 mb-2" rows="3" value={technology_adopted_comment} onChange={(e) => setTechnologyAdoptedComment(e.target.value)} placeholder="Details in brief" style={{ border: '2px solid #000' }} />


                        {/* Quality Compliance */}
                        <h5>9. Quality Compliance (tick as applicable and mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>a. ISO</td>
                                    <td><input type="checkbox" checked={quality_compliance_iso} onChange={(e) => setQualityComplianceIso(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>b. BIS</td>
                                    <td><input type="checkbox" checked={quality_compliance_bis} onChange={(e) => setQualityComplianceBis(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>c. GMP/WHO/FDA/HACCP</td>
                                    <td><input type="checkbox" checked={quality_compliance_gmp_who_fda_haccp} onChange={(e) => setQualityComplianceGmpWhoFdaHaccp(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>d. Any other, to mention</td>
                                    <td><input type="checkbox" checked={quality_compliance_other} onChange={(e) => setQualityComplianceOther(e.target.checked)} /></td>
                                </tr>
                            </tbody>
                        </table>
                        <textarea className="form-control mt-2 mb-2" rows="3" value={quality_compliance_comment} onChange={(e) => setQualityComplianceComment(e.target.value)} placeholder="Details in brief" style={{ border: '2px solid #000' }} />

                        <h5>10. Management Functions – Has (tick as applicable and mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>a. Human Resources Department</td>
                                    <td><input type="checkbox" checked={management_functions_human_resources_department} onChange={(e) => setManagementFunctionsHumanResourcesDepartment(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>b. Finance & Accounts</td>
                                    <td><input type="checkbox" checked={management_functions_finance_accounts} onChange={(e) => setManagementFunctionsFinanceAccounts(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>c. Marketing/ Business Development</td>
                                    <td><input type="checkbox" checked={management_functions_marketing_business_development} onChange={(e) => setManagementFunctionsMarketingBusinessDevelopment(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>d. R & D</td>
                                    <td><input type="checkbox" checked={management_functions_r_d} onChange={(e) => setManagementFunctionsRD(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>e. Internal Audit</td>
                                    <td><input type="checkbox" checked={management_functions_internal_audit} onChange={(e) => setManagementFunctionsInternalAudit(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>f. Quality Assurance</td>
                                    <td><input type="checkbox" checked={management_functions_quality_assurance} onChange={(e) => setManagementFunctionsQualityAssurance(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>g. Any other, please specify</td>
                                    <td><input type="checkbox" checked={management_functions_other} onChange={(e) => setManagementFunctionsOther(e.target.checked)} /></td>
                                </tr>
                            </tbody>
                        </table>
                        <textarea className="form-control mt-2 mb-2" rows="3" value={management_functions_comment} onChange={(e) => setManagementFunctionsComment(e.target.value)} placeholder="Details in brief" style={{ border: '2px solid #000' }} />

                        <h5>12. Level of IT intervention (tick as applicable and mention details)</h5>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>Option</th>
                                    <th>Select</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>a. Use of ERP</td>
                                    <td><input type="checkbox" checked={level_of_it_intervention_use_of_erp} onChange={(e) => setLevelOfITInterventionUseOfERP(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>b. Customized software</td>
                                    <td><input type="checkbox" checked={level_of_it_intervention_customized_software} onChange={(e) => setLevelOfITInterventionCustomizedSoftware(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>c. General office solutions</td>
                                    <td><input type="checkbox" checked={level_of_it_intervention_general_office_solutions} onChange={(e) => setLevelOfITInterventionGeneralOfficeSolutions(e.target.checked)} /></td>
                                </tr>
                                <tr>
                                    <td>d. No IT facility</td>
                                    <td><input type="checkbox" checked={level_of_it_intervention_no_it_facility} onChange={(e) => setLevelOfITInterventionNoITFacility(e.target.checked)} /></td>
                                </tr>
                            </tbody>
                        </table>
                        <textarea className="form-control mt-2 mb-2" rows="3" value={level_of_it_intervention_comment} onChange={(e) => setLevelOfITInterventionComment(e.target.value)} placeholder="Details in brief" style={{ border: '2px solid #000' }} />

                        {/* In receipt of any Award */}
                        <h5>13. In receipt of any Award/recognition of repute</h5>
                        <div className="mb-3">
                            <label className="form-label">YES/NO</label>
                            <div>
                                <input type="radio" name="award" checked={award_recognition_yes} onChange={() => setAwardRecognitionYes(true)} /> YES
                                <input type="radio" name="award" checked={award_recognition_no} onChange={() => setAwardRecognitionNo(true)} /> NO
                            </div>
                            <textarea className="form-control mt-2" rows="3" value={award_recognition_comment} onChange={(e) => setAwardRecognitionComment(e.target.value)} placeholder="If yes, to mention details" style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* Strategic Plan */}
                        <h5>14. Does the Organization have a Strategic Plan for future growth</h5>
                        <div className="mb-3">
                            <label className="form-label">YES/NO</label>
                            <div>
                                <input type="radio" name="strategicPlan" checked={strategic_plan_for_future_yes} onChange={() => setStrategicPlanForFutureYes(true)} /> YES
                                <input type="radio" name="strategicPlan" checked={strategic_plan_for_future_no} onChange={() => setStrategicPlanForFutureNo(true)} /> NO
                            </div>
                            <textarea className="form-control mt-2" rows="3" value={strategic_plan_for_future_comment} onChange={(e) => setStrategicPlanForFutureComment(e.target.value)} placeholder="If yes, mention details" style={{ border: '2px solid #000' }}></textarea>
                        </div>

                        {/* About Product/Service */}
                        <h3>A. About Product/ Service:</h3>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Description</th>
                                    <th>Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Description of product / service</td>
                                    <td><input type="text" className="form-control" value={about_product_service_description} onChange={(e) => setAboutProductServiceDescription(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Capacity</td>
                                    <td><input type="text" className="form-control" value={about_product_service_capacity} onChange={(e) => setAboutProductServiceCapacity(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Features of product</td>
                                    <td><input type="text" className="form-control" value={about_product_service_features} onChange={(e) => setAboutProductServiceFeatures(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Uniqueness, if any</td>
                                    <td><input type="text" className="form-control" value={about_product_service_uniqueness} onChange={(e) => setAboutProductServiceUniqueness(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>Market</td>
                                    <td><input type="text" className="form-control" value={about_product_service_market} onChange={(e) => setAboutProductServiceMarket(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>6</td>
                                    <td>Export content in Turnover</td>
                                    <td><input type="text" className="form-control" value={about_product_service_export_content_in_turnover} onChange={(e) => setAboutProductServiceExportContentInTurnover(e.target.value)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        {/* About Chief Promoter */}
                        <h3>B. About Chief Promoter:</h3>
                        <table className="table table-bordered" style={{ border: '2px solid #000' }}>
                            <thead>
                                <tr>
                                    <th>S No</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Educational qualification</td>
                                    <td><input type="text" className="form-control" value={about_chief_promoter_educational_qualification} onChange={(e) => setAboutChiefPromoterEducationalQualification(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Experience in line</td>
                                    <td><input type="text" className="form-control" value={about_chief_promoter_experience_in_line} onChange={(e) => setAboutChiefPromoterExperienceInLine(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Are you first generation entrepreneur?</td>
                                    <td><input type="text" className="form-control" value={about_chief_promoter_first_generation_entrepreneur} onChange={(e) => setAboutChiefPromoterFirstGenerationEntrepreneur(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Contribution to the Organization</td>
                                    <td><input type="text" className="form-control" value={about_chief_promoter_contribution_to_organisation} onChange={(e) => setAboutChiefPromoterContributionToOrganisation(e.target.value)} /></td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>Any relevant details, to specify</td>
                                    <td><input type="text" className="form-control" value={about_chief_promoter_relevant_details} onChange={(e) => setAboutChiefPromoterRelevantDetails(e.target.value)} /></td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="mb-3">
                            <label className="form-label">Signature:</label>
                            <input value={signatureUrl} onChange={(e) => setSignatureUrl(e.target.value)} type="file" className="form-control" placeholder="Signature" style={{ border: '2px solid #000' }} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Name:</label>
                            <input value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control" placeholder="Name" style={{ border: '2px solid #000' }} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Designation:</label>
                            <input value={designation} onChange={(e) => setDesignation(e.target.value)} type="text" className="form-control" placeholder="Designation" style={{ border: '2px solid #000' }} />
                        </div>

                        <div className='mb-2' style={{ textAlign: 'center' }}>
                            <button onClick={handleSubmit2} className="btn btn-primary w-100">Submit</button>
                        </div>

                        <p><strong>(To be signed by CEO/MD of Organization)</strong></p>

                    </form>
                </div>
            )}

            {formStep === 3 && (
                <div className="container">
                    <h3 className='text-center'>WOMEN ACHIEVER AWARD OF EXCELLENCE</h3>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3" >
                            <label className="form-label"><FaUser /> 1. Name and Designation</label>
                            <input type="text" className="form-control" name='name' value={namee} onChange={(e) => setNamee(e.target.value)} style={{ border: '2px solid #000', }} />
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><FaBirthdayCake /> 2. Age</label>
                            <input type="number" className="form-control" name="age" value={age} onChange={(e) => setAge(e.target.value)} style={{ border: '2px solid #000', }} />
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><FaGraduationCap /> Qualification (mention details)</label>
                            <table className="table table-bordered" style={{ border: '2px solid #000', }}>
                                <thead>
                                    <tr>
                                        <th>S NO</th>
                                        <th>Discipline</th>
                                        <th>PG</th>
                                        <th>Graduate</th>
                                        <th>Other</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {qualification.discipline.map((_, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td><input type="text" value={qualification.discipline[index]} onChange={(e) => handleQualificationChange(index, "discipline", e.target.value)} disabled className="form-control" /></td>
                                            <td><input value={qualification.pg[index]} onChange={(e) => handleQualificationChange(index, "pg", e.target.value)} className="form-control" /></td>
                                            <td><input value={qualification.graduate[index]} onChange={(e) => handleQualificationChange(index, "graduate", e.target.value)} className="form-control" /></td>
                                            <td><input value={qualification.other[index]} onChange={(e) => handleQualificationChange(index, "other", e.target.value)} className="form-control" /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><FaBriefcase /> Experience (mention details)</label>
                            <table className="table table-bordered" style={{ border: '2px solid #000', }}>
                                <thead>
                                    <tr>
                                        <th>Total (in Years)</th>
                                        <th>In same line</th>
                                        <th>In same Organization</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><input type="number" value={experience.total_years} onChange={handleExperienceChange} name="total_years" className="form-control" /></td>
                                        <td><input type="text" value={experience.same_line} onChange={handleExperienceChange} name="same_line" className="form-control" /></td>
                                        <td><input type="text" value={experience.same_organization} onChange={handleExperienceChange} name="same_organization" className="form-control" /></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><FaHandHoldingHeart /> 5. Is nominee Chief Promotor or employee or social activist or entrepreneur or other</label>
                            <input type="text" className="form-control" value={contributor_role} onChange={(e) => setContributorRole(e.target.value)} style={{ border: '2px solid #000', }} />
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><FaHandHoldingHeart /> 6. Is nominee a first-generation entrepreneur?</label>
                            <input type="text" className="form-control" name="first_gen_entrepreneur" value={first_gen_entrepreneur} onChange={(e) => setFirstGenEntrepreneur(e.target.value)} style={{ border: '2px solid #000', }} />
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><FaFileSignature /> 7. Contribution of nominee for Organization/society (a brief on each of the following, as applicable)</label>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" style={{ border: '2px solid #000', }} value="Positive effect on turnover" checked={checkboxes.includes("Positive effect on turnover")} onChange={handleCheckboxChangeg} />
                                <label className="form-check-label" htmlFor="turnover">Positive effect on turnover/productivity/quality/use of quality tools/areas of operation/Introduction of new practices/Innovations/HR practices/Any turn around activity/Devising strategic plan and implementing/Use of innovative IT practices/MIS/Development of R&D and use of the technology/Energy conservation/CSR activities/Impact on Society</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="Received any Recognition/ awards of repute" id="productivity" checked={checkboxes.includes('Received any Recognition/ awards of repute')} onChange={handleCheckboxChangeg} style={{ border: '2px solid #000', }} />
                                <label className="form-check-label" htmlFor="productivity">Received any Recognition/ awards of repute</label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="Any relevant aspect, to specify" id="quality" checked={checkboxes.includes('Any relevant aspect, to specify')} onChange={handleCheckboxChangeg} style={{ border: '2px solid #000', }} />
                                <label className="form-check-label" htmlFor="quality">Any relevant aspect, to specify</label>
                            </div>
                            <textarea className="form-control" rows="5" name="contribution_text" value={contribution_text} onChange={(e) => setContributionText(e.target.value)} style={{ border: '2px solid #000', }}></textarea>
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><FaFileSignature /> 8. Any contribution/performance, which can be said as significant, which helped the Organization</label>
                            <textarea className="form-control" rows="5" name="comments" value={comments} onChange={(e) => setComments(e.target.value)} style={{ border: '2px solid #000', }}></textarea>
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><FaFileSignature /> 9. Write in 200 words why you consider eligible for this award</label>
                            <textarea className="form-control" rows="5" name="comment1" value={comment1} onChange={(e) => setComment1(e.target.value)} style={{ border: '2px solid #000', }}></textarea>
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><FaFileSignature /> Signature</label>
                            <input type="file" className="form-control" onChange={handleFileChange} style={{ border: '2px solid #000', }} />
                        </div>

                        <div className="mb-3">
                            <label className="form-label"><FaUser /> Name</label>
                            <input type="text" className="form-control" name="name1" value={name1} onChange={(e) => setName1(e.target.value)} style={{ border: '2px solid #000', }} />
                        </div>
                        <div className="mb-3">
                            <label className="form-label"><FaCalendarAlt /> Date</label>
                            <input type="date" className="form-control" value={date} onChange={(e) => setDate(e.target.value)} style={{ border: '2px solid #000', }} />
                        </div>

                        <button type="submit" className="btn btn-primary btn-sm mb-2 w-100">Submit</button>

                        <div className="mb-0">
                            <h6 style={{ textTransform: 'uppercase', textAlign: 'center' }}>To be countersigned by CEO/MD of Organization, if nominee is employee</h6>
                            <hr />
                        </div>

                        <button type="button" className="btn btn-info btn-sm mb-2" onClick={handleModalShow}>Eligibility Criteria</button>
                    </form>

                    <div className={`modal fade ${showModal ? 'show' : ''}`} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden={!showModal} style={{ display: showModal ? 'block' : 'none' }}>
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title text-center" id="exampleModalLabel">Eligibility Criteria</h5>
                                    <button type="button" className="btn-close" onClick={handleModalClose} aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    <ul>
                                        <li>The nominee should be of Manager level in a Corporate or Govt sector or an entrepreneur or Social Activist in the states of Telangana or Andhra Pradesh.</li>
                                        <li>The achievements/innovative/work should have shown consistent outcomes for three consecutive years.</li>
                                        <li>The Individual should have achieved significant and conspicuous success in her working life of not less than 10 years.</li>
                                        <li>The progress and accomplishments made by the Individual should be measurable, and preferably distinctive, with noteworthy contribution to the stated field or vocation.</li>
                                        <li>The Individual shall have depicted convincing personal values, ethics, morals, rectitude and integrity in her business/profession and possess vital qualities of leadership, vision, passion, courage and magnanimity.</li>
                                        <li>The Individual shall have demonstrated her support for innovation, enterprise, creativity and development of future leadership, and made significant contribution in her work.</li>
                                        <li>The Individual must have made a positive and discernible impact in raising the standards of relevant practices, processes and policies in the stated line of Work.</li>
                                        <li>The Individual shall also have established her concern for welfare of society and progress of the Nation in one express form or the other.</li>
                                        <li>The Organization should give a detailed list of achievements of the nominee, duly attested by their Head if employee, and by way of self-attestation, in case of entrepreneur or social activist.</li>
                                    </ul>
                                    <h4>FORM 1, 2 & 3 TO BE FILLED</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <footer style={{ backgroundColor: '#f1f1f1', padding: '20px 0', textAlign: 'center', marginTop: 'auto' }}>
                <div>
                    <p style={{ margin: '0', fontSize: '14px' }}>
                        Powered by
                        <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#4CAF50', textDecoration: 'none', marginLeft: '5px', }}>
                            EMedha Technologies
                        </a>
                    </p>
                    <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer">
                        <img src={L1} alt="EMedha Technologies Logo" style={{ width: '200px', height: 'auto', marginTop: '10px' }} />
                    </a>
                </div>
            </footer>
        </>
    );
};

export default Form3f3;
